import { render } from "./Location.vue?vue&type=template&id=81022a62&scoped=true"
const script = {}

import "./Location.vue?vue&type=style&index=0&id=81022a62&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81022a62"]])

export default __exports__